import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
];

//FOR 880 MODULE ONLY
export default class Product_Buyers extends Framework.Components.View {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-buyer" onClick={this.toggle('modalBuyer')} size="sm" color="primary">
						<i className="fa fa-shopping-bag"/>&nbsp;&nbsp;Add Buyer
					</Button>
				</Framework.Components.PageBar>

				<div>
					<Collections.Custom880Buyers
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						scannedCode={this.props.scannedCode}
					/>
				</div>

				<UniversalModalOverride
					name="Product Buyer"
					object={Objects.Custom880Buyer}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					toggle={this.state['modalBuyer']}
					reportClose={this.reportClose('modalBuyer')}
					afterSave={this.handleAfterSave}
				/>
			</div>
		);
	}
}

